import Addin from '../store/schema/Addin';
import AddinCommandFactory from './AddinCommandFactory';
import Control from 'owa-service/lib/contract/Control';
import Extension from 'owa-service/lib/contract/Extension';
import ExtensionEvent from 'owa-service/lib/contract/ExtensionEvent';
import ExtensionPoint from 'owa-service/lib/contract/ExtensionPoint';
import getExtensionPoint from './getExtensionPoint';
import Group from 'owa-service/lib/contract/Group';
import IAddin from '../store/schema/interfaces/IAddin';
import IAddinCommand from '../store/schema/interfaces/IAddinCommand';
import IContextualAddinCommand from '../store/schema/interfaces/IContextualAddinCommand';
import Tab from 'owa-service/lib/contract/Tab';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { ObservableMap } from 'mobx';

export default class AddinFactory {
    constructor(private addinCommandFactory: AddinCommandFactory) {}

    CreateAddinIfEntryPointSupported(extension: Extension, mode: ExtensibilityModeEnum): IAddin {
        let commands: ObservableMap<string, IAddinCommand>;
        if (mode == ExtensibilityModeEnum.TrapOnSendEvent) {
            commands = this.GetEventsAddinCommands(
                extension.ExtensionPointCollection.Events,
                extension
            );
        } else if (mode == ExtensibilityModeEnum.DetectedEntity) {
            commands = this.GetContextualAddinCommand(
                getExtensionPoint(extension.ExtensionPointCollection, mode),
                extension
            );
        } else {
            commands = this.GetAddinCommands(
                getExtensionPoint(extension.ExtensionPointCollection, mode),
                extension
            );
        }
        return !commands ? null : new Addin(extension, commands);
    }

    GetAddinCommands(
        extensionPoint: ExtensionPoint,
        extension: Extension
    ): ObservableMap<string, IAddinCommand> {
        if (!extensionPoint) {
            return null;
        }
        const addincommands: { [key: string]: IAddinCommand } = {};
        extensionPoint.Tabs.forEach((tab: Tab) => {
            tab.Groups.forEach((group: Group) => {
                group.Controls.forEach((control: Control) => {
                    addincommands[control.Id] = this.addinCommandFactory.CreateAddinCommand(
                        control,
                        tab,
                        group,
                        extension
                    );
                });
            });
        });
        return new ObservableMap<string, IAddinCommand>(addincommands);
    }

    GetContextualAddinCommand(
        extensionPoint: ExtensionPoint,
        extension: Extension
    ): ObservableMap<string, IAddinCommand> {
        if (!extensionPoint) {
            return null;
        }
        const id = extension.Id;
        const commands = {};
        commands[id] = this.addinCommandFactory.CreateContextualAddinCommand(
            extensionPoint,
            extension
        );
        return new ObservableMap<string, IContextualAddinCommand>(commands);
    }

    GetEventsAddinCommands(
        events: ExtensionEvent[],
        extension: Extension
    ): ObservableMap<string, IAddinCommand> {
        if (!events) {
            return null;
        }

        const addincommands: { [type: number]: IAddinCommand } = {};
        events.forEach((event: ExtensionEvent) => {
            addincommands[event.Type] = this.addinCommandFactory.CreateEventAddinCommand(
                event,
                extension
            );
        });

        return new ObservableMap<string, IAddinCommand>(addincommands);
    }
}
